import type {ReactElement} from 'react';
import React from 'react';
import styles from './quality-item.module.scss';
import {Text, TextSize} from '@Components/text';
import {Tag} from '@Components/tag';
import {DesignQualityType} from '@Components/download-panel/components/quality-item/quality-item.types';

interface QualityItemProps {
  id: string;
  text: string;
  tagText?: string;
  isSelected?: boolean;
  durationLimit?: number;
  type?: DesignQualityType;
  onClick: (id: string) => void;
  bullets?: BulletItem[];
}

interface BulletItem {
  text: string;
  showSuccessBullet?: boolean;
}

export function QualityItem({tagText = '', bullets = [], type = DesignQualityType.BASIC, isSelected = false, ...props}: QualityItemProps): ReactElement {
  const getBullet = (showSuccessBullet = false): ReactElement => {
    return <div className={`${styles.bullet} ${showSuccessBullet ? styles.success : ''} radius-round`} />;
  };
  return (
    <li
      onClick={(): void => {
        if (isSelected) {
          return;
        }
        props.onClick(props.id);
      }}
      id={props.id}
      className={`${styles.container} ${isSelected ? styles.selected : ''} flex flex-v-row radius-8 hover-transition-all`}
    >
      <div className={`flex-row-justify-between flex-items-center`}>
        <Text bold val={props.text} size={TextSize.XSMALL} className={isSelected ? 'content-primary' : 'content-body'} />
        {tagText ? <Tag className="radius-round" text={tagText} /> : null}
      </div>

      {bullets && bullets.length > 0 ? (
        <div className="flex-v-row spacing-m-t-2">
          {bullets.map((bullet, index) => {
            return (
              <div key={index} className="flex-h-row flex-items-center">
                {getBullet(bullet.showSuccessBullet)}
                <Text className="content-sub-text" size={TextSize.XXSMALL} val={bullet.text} />
              </div>
            );
          })}
        </div>
      ) : null}
    </li>
  );
}
